const openCart = () => {
    document.body.dataset.cartModalOpen = 'true'
    document.addEventListener('keyup', handleEscape)
}

const closeCart = () => {
    delete document.body.dataset.cartModalOpen
    document.removeEventListener('keyup', handleEscape)
}

const handleEscape = (event) => {
    if (event.key === 'Escape') closeCart()
}

document.addEventListener('click', (event) => {
    if (event.target.closest('[data-close-cart]')) closeCart()
})

export {
    openCart,
    closeCart
}
